module.exports = __webpack_public_path__ + "static/media/client3.e2c26bc7.svg";